/* SpawnAnything — Boss-Kampf (Phase D3, variant "eigener Modus", 02.10.2026): three giant bosses, each a mission in the
   campaign format (the campaign UI and the sim's campaign feature run it) with `boss: true` and `bossRules` for the
   sim (feature:boss in sim.worker.js: rage below `enrage` of its HP, a ground slam every `stomp` seconds). The player
   buys a mixed army (up to 4 troops) from the roster; fewer points spent = more stars, like the campaign.
   Budgets: measured with .exp/bossCal.mjs (the best single troop wins with ~40-45 % of the budget). */
import { CAMPAIGN_MISSIONS } from './campaign.js';
import { ERAS } from './eras.js';

const mapOf = id => { const m = CAMPAIGN_MISSIONS.find(q => q.id === id); return { styleKey: m.map.styleKey, seed: m.map.seed, terrain: { ...m.map.terrain, battleRadius: Math.max(90, m.map.terrain.battleRadius) } }; };
const unitsOf = (...eras) => [...new Set(eras.flatMap(k => (ERAS.find(e => e.key === k) || { units: [] }).units))];

export const BOSSES = [
  {
    id: 'boss-trex', era: 'urzeit', title: 'Der T-Rex-König', icon: 'ti-bone',
    briefing: 'Ein T-Rex so groß wie ein Haus stampft auf das Dorf zu. Unter der Hälfte seiner Kraft gerät er in Raserei und wird schneller.',
    map: mapOf('urzeit-1'), boss: { type: 'trex', size: 4 }, rules: { enrage: 0.5, stomp: 9 },
    pool: unitsOf('urzeit', 'antike'), budget: 119000,
    tip: 'Verteil deine Truppen: Seine Stampfwelle trifft alles in der Nähe. Schützen aus der zweiten Reihe halten länger.',
  },
  {
    id: 'boss-titan', era: 'weltkrieg', title: 'Mecha-Titan', icon: 'ti-robot',
    briefing: 'Ein haushoher Kampfroboter mit Plasmaklinge marschiert über das Schlachtfeld. Halb zerstört dreht er durch.',
    map: mapOf('weltkrieg-1'), boss: { type: 'optimus', size: 5 }, rules: { enrage: 0.5, stomp: 8 },
    pool: unitsOf('mittelalter', 'weltkrieg'), budget: 190500,
    tip: 'Panzer und Raketen schaden viel, aber die Stampfwelle wirft leichte Truppen um.',
  },
  {
    id: 'boss-wurm', era: 'zukunft', title: 'Die Weltraumwurm-Königin', icon: 'ti-planet',
    briefing: 'Die Königin der Weltraumwürmer bricht aus dem Boden. Sie ist riesig, zäh und wird mit jeder Wunde wilder.',
    map: mapOf('zukunft-3'), boss: { type: 'weltraumwurm', size: 2 }, rules: { enrage: 0.6, stomp: 7 },
    pool: unitsOf('moderne', 'zukunft').filter(k => k !== 'weltraumwurm'), budget: 82900,
    tip: 'Reichweite ist alles: Wer nah dran steht, wird von der Stampfwelle erwischt.',
  },
];

/** the boss as a mission in the campaign format */
export function bossMission(b) {
  return {
    id: b.id, era: b.era, title: b.title, briefing: b.briefing, boss: true, bossRules: { ...b.rules },
    map: b.map, world: { weather: 'klar', crater: true, infection: false, conversion: false },
    player: { armies: [{ type: b.pool[0], count: 1, size: 1 }], buildings: [], tools: [] },
    enemy: { armies: [{ type: b.boss.type, count: 1, size: b.boss.size }], buildings: [], waves: [] },
    objectives: [{ kind: 'destroy_all' }], unlocks: {}, tip: b.tip,
    puzzle: { budget: b.budget, pool: b.pool, stars: [0.75, 0.5] },
  };
}
export const BOSS_MISSIONS = BOSSES.map(bossMission);
